type args = { method?: string, url: string, body: any };

export function fireAndForget({ method = 'POST', url, body }: args) {
  const bodyAsString = JSON.stringify(body);
  if (typeof navigator.sendBeacon !== 'undefined' && method === 'POST') {
    navigator.sendBeacon(url, bodyAsString);
  } else if (typeof fetch !== 'undefined') {
    // noinspection JSIgnoredPromiseFromCall
    fetch(url, { method, body: bodyAsString });
  } else if (XMLHttpRequest) {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.send(bodyAsString);
  }
}